import { Button, Typography } from '@/components';
import { TextStyles } from '@/constants';
import { ButtonSize, ButtonVariant } from '@/interfaces';
import styled from 'styled-components';
import { PMTAdsense } from '../PMTAdsense';

export const MainText = styled(Typography).attrs({
  variant: TextStyles['Heading 3'],
})({});

export const SubText = styled(Typography).attrs({
  variant: TextStyles['Body Text Large'],
})({});

export const ESMainText = styled(MainText)({
  maxWidth: 556,
});

export const Divider = styled(Typography).attrs({
  variant: TextStyles['Overline'],
})(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing[20],

  ['> span']: {
    textTransform: 'uppercase',
    color: theme.colors.inactiveBlack,
    margin: `0 ${theme.spacing[8]}`,
    whiteSpace: 'nowrap',
  },

  [':before, :after']: {
    content: '""',
    width: '100%',
    height: 1,
    backgroundColor: theme.colors.inactiveBlack,
    display: 'block',
    borderRadius: 2,
  },
}));

export const JoinUsButton = styled(Button).attrs({
  variant: ButtonVariant.Primary,
  size: ButtonSize.Large,
})(({ theme }) => ({
  width: '100%',
  marginBottom: theme.spacing[20],
  textAlign: 'center',
}));

export const CustomNoParcelsAddedAdsense = styled(PMTAdsense)(({ theme }) => ({
  marginTop: theme.spacing[10],
  borderTop: 'none',
}));

const DefaultContent = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  textAlign: 'center',

  [`> ${MainText}, > ${SubText}`]: {
    color: theme.colors.inactiveBlack,
  },
}));

export const NotLoggedInContent = styled(DefaultContent)(({ theme }) => ({
  marginTop: theme.spacing[16],
  padding: `${theme.spacing[32]} ${theme.spacing[20]}`,

  [`> ${MainText}`]: {
    marginTop: theme.spacing[32],
  },

  [`> ${SubText}`]: {
    marginTop: theme.spacing[8],
  },

  [`${theme.mediaBreakpointUp.lg}`]: {
    marginTop: theme.spacing[24],
    padding: `${theme.spacing[32]} 0`,
  },
}));

export const ESDefaultContent = styled(DefaultContent)(({ theme }) => ({
  marginBottom: theme.spacing[28],
  marginTop: 0,
  padding: 0,

  [`> ${ESMainText}`]: {
    marginTop: theme.spacing[24],
  },

  [`${theme.mediaBreakpointUp.lg}`]: {
    padding: `${theme.spacing[16]} 0`,
    marginBottom: theme.spacing[24],

    [`> ${ESMainText}`]: {
      marginTop: theme.spacing[32],
    },
  },
}));

export const ESLoggedInDivider = styled(Divider)(({ theme }) => ({
  margin: `${theme.spacing[24]} 0`,
}));

export const ESLoggedInWrapper = styled(DefaultContent)(({ theme }) => ({
  gridRowGap: theme.spacing[24],

  [`> ${MainText}`]: {
    margin: 0,
  },

  ['> button']: {
    margin: 0,
  },

  [`${theme.mediaBreakpointUp.lg}`]: {
    paddingTop: theme.spacing[24],
  },
}));
